export default {
  GET_CATEGORIES: ({ page = 1, rowsPerPage = 10 }) => `core/categories/?page=${page}&page_size=${rowsPerPage}`,
  GET_AUDIT_CATEGORIES: 'core/categories',
  CREATE_CATEGORY: 'core/categories/',
  UPDATE_CATEGORY: (id) => `core/categories/${id}/`,
  DELETE_CATEGORY: (id) => `core/categories/${id}/`,
};
